import React from "react";

import DynamicRoute from "$src/core/components/templates/DynamicRoute/DynamicRoute";

const Route: React.FC = () => <DynamicRoute slot={5} />;

export default Route;
